import React, { useState, useEffect } from 'react';
import PersonalRecordService from './PersonalRecordService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './jsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';

const PersonalRecordTable = ({refreshList, setRefreshList}) => {
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();


  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };

  const deletePersonalRecord = identification => {
    PersonalRecordService.deletePersonalRecord(identification)
      .then(response => {
        console.log(response);
      })
      .catch(error => console.log(error));
  };

  const jsonSchema = schema;

  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    PersonalRecordService.retrieveAllPersonalRecordsByUser()
      .then(data => {
        const updatedData = data.map(item => {
          const updatedItem = { ...item, date: new Date(item.date).getDate() + '/' + (new Date(item.date).getMonth() + 1) + '/' + new Date(item.date).getFullYear() };
            return updatedItem;
        });
        console.log('updatedData', updatedData);
        const actionButtons = [
          {
            icon: 'trash-alt',
            onClick: identifier => {
              deletePersonalRecord(identifier);
              setRefreshList(true);
            },
            className: 'p-0',
            title: 'Delete',
            variant: 'action'
          }
        ];

        setNoDataToShow(updatedData.length === 0);
        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);



  return (
    <>
      {error}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any PersonalRecord to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default PersonalRecordTable;